import http from '../const/http-common'

/**
 * Upload a PowerPoint template (.pptx) and extract metadata and placeholders.
 * @param {File} file - .pptx file
 * @returns {Promise} - { metadata, placeholders, message }
 */
const extractMetadata = (file) => {
  const token = localStorage.getItem('token')
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
  }
  const formData = new FormData()
  formData.append('template', file)
  return http.post('/v1/user/document/extract-metadata', formData, { headers })
}

export default {
  extractMetadata,
}
